__turbopack_context__.v({
  "hover": "user-images-module-scss-module__3kbX4q__hover",
  "hoverImage": "user-images-module-scss-module__3kbX4q__hoverImage",
  "hoverInline": "user-images-module-scss-module__3kbX4q__hoverInline",
  "image": "user-images-module-scss-module__3kbX4q__image",
  "lightboxBorder": "user-images-module-scss-module__3kbX4q__lightboxBorder",
  "list": "user-images-module-scss-module__3kbX4q__list",
});
